var staticParseInt = parseInt

module.exports = staticParseInt



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticParseInt.js
// module id = 63
// module chunks = 98